import * as React from 'react';
import NoodleDropdown from 'components/uielements/Dropdown';
import Typeahead from 'components/uielements/Typeahead';
import { isDropdown } from 'utils/form';
import type { SelectInputProps } from '../FormInput.types';

const SelectInput = (props: SelectInputProps): React.ReactElement<any> | null => {
  const {
    isDropdown: isDropdownControl,
    maxLength,
    name,
    onSuggestionsUpdated,
    onSuggestionsCleared,
    onSuggestionsFetched,
    onSuggestionSelected,
    options,
    suggestions,
  } = props;

  if (isDropdownControl || isDropdown(options)) {
    return <NoodleDropdown {...props} />;
  }

  return typeof onSuggestionSelected === 'function' ? (
    <Typeahead
      {...props}
      hasToSelect
      length={maxLength}
      onChange={onSuggestionsUpdated}
      onSuggestionsClearRequested={onSuggestionsCleared}
      onSuggestionsFetchRequested={onSuggestionsFetched}
      onSuggestionSelected={(e, suggestion) => onSuggestionSelected(suggestion, name)}
      suggestions={suggestions}
    />
  ) : null;
};

export default SelectInput;
